// client/src/lib/env.ts
const ORIGIN =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : '';

export const API_BASE =
  (import.meta.env.VITE_API_BASE as string) ||
  (ORIGIN ? `${ORIGIN}/api` : '/api');

export const SOCKET_URL =
  (import.meta.env.VITE_SOCKET_URL as string) ||
  ORIGIN ||
  '';

export const SOCKET_PATH =
  (import.meta.env.VITE_SOCKET_PATH as string) || '/socket.io';

export const TURN = {
  serverUrl: import.meta.env.VITE_TURN_SERVER_URL || '',
  username: import.meta.env.VITE_TURN_USERNAME || '',
  credential: import.meta.env.VITE_TURN_CREDENTIAL || ''
};

// Legacy exports for backward compatibility (deprecated)
export const SERVER_URL = SOCKET_URL;
export const SOCKET_CONFIG = {
  url: SOCKET_URL,
  path: SOCKET_PATH
};

// Helper function to determine if running on localhost
export const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname === '0.0.0.0';
};

// Helper function to get server URL (deprecated - use SOCKET_URL instead)
export const getServerUrl = (): string => {
  if (import.meta.env.VITE_SOCKET_URL) {
    return import.meta.env.VITE_SOCKET_URL;
  }
  
  if (isLocalhost()) {
    return 'http://localhost:5000';
  } else {
    // If accessing from network device, use network IP
    return 'http://192.168.1.18:5000';
  }
};